export default "__VITE_ASSET__8285cb11__"